export function normalizeText(text: string): string {
  const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç',
    to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc',
    mapping = {};

  for (let i = 0, j = from.length; i < j; i++) {
    mapping[from.charAt(i)] = to.charAt(i);
  }
  const ret = [];
  for (let i = 0, j = text.length; i < j; i++) {
    const c = text.charAt(i);
    if (Object.prototype.hasOwnProperty.call(mapping, text.charAt(i))) {
      ret.push(mapping[c]);
    } else {
      ret.push(c);
    }
  }

  const url = ret.join('').replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase();
  let actualCharIsSpecialCharacter = false;
  let lastChariIsSpecialCharacter = false;
  let newUrl = '';
  for (let i = 0; i < url.length; i++) {
    actualCharIsSpecialCharacter = url.charAt(i).match(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/) !== null;
    if (i > 0) {
      lastChariIsSpecialCharacter = url.charAt(i - 1).match(/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/) !== null;
    }
    newUrl += (i === 0 || i === url.length - 1) && actualCharIsSpecialCharacter ? '' : url.charAt(i);
    if (lastChariIsSpecialCharacter && actualCharIsSpecialCharacter) {
      newUrl = newUrl.slice(0, newUrl.length - 1);
    }
  }
  return newUrl;
}
